import React from 'react'
import { Button } from 'react-bulma-components'

interface BulkActionsButtonProps {
  selectedCount: number
  onModifyContractualSchedules: () => void
}

/**
 * Button component for bulk actions on selected workers
 */
const BulkActionsButton: React.FC<BulkActionsButtonProps> = ({
  selectedCount,
  onModifyContractualSchedules,
}) => {
  const isDisabled = selectedCount === 0

  return (
    <Button
      color="primary"
      onClick={onModifyContractualSchedules}
      disabled={isDisabled}
      size="small"
    >
      Attribuer horaire contractuel ({selectedCount})
    </Button>
  )
}

export default BulkActionsButton
